import * as React from 'react';
import { IListItem } from '../../common/classes/list-item';
import { IAppState } from '../../common/classes/app';
import Pager from '../../common/components/pager';
import { ConnectedSort } from '../../common/components/sort-options';
import { ConnectedSortDate, Sort } from '../../common/components/sort-options-date';
import { ConnectedResultePerPageDropdown } from '../../common/components/result-per-page';
import ConnectedDashBoard from '../../common/components/result-dashboard';
import { ConnectedClearAll } from '../../common/components/clear-all';

import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { FilterType } from '../../common/classes/filter-type';
import { Responsive } from '../../common/components/responsive';

interface IExternalProps<T = IListItem> {
    listItemComponent: (props: T) => JSX.Element;
    itemType: string;
}

interface StateToProps {
    list: IListItem[];
    numberOfPages: number;
    isLoading: boolean;
    filterApplied: boolean;
}

interface DispatchToProps {

}

type IListContainerProps<T = IListItem> = IExternalProps<T> & StateToProps & DispatchToProps;

export const ListContainer: React.StatelessComponent<IListContainerProps> = props => {

    var providers = props.list.filter(it => it.typeOfResult == "ProviderDetailResult");
    var locations = props.list.filter(it => it.typeOfResult == "LocationDetailResult");
    var events = props.list.filter(it => it.typeOfResult == "EventDetailResult");
    var care = props.list.filter(it => it.typeOfResult == "GenericSearchResult");
    var showResultPerPage = props.filterApplied;
    var maxItems = 3;

    var total = providers.length > 0 ? providers[0].moreItemsOfType : 0 +
        locations.length > 0 ? locations[0].moreItemsOfType : 0 +
            events.length > 0 ? events[0].moreItemsOfType : 0 +
                care.length > 0 ? care[0].moreItemsOfType : 0 ;

    return (
        <div className="adage-search-results">
            {props.isLoading ?
                null
                :
                <div className="adage-search-results-header">
                    <div className="adage-search-results-header-display">
                        {
                            total > 0 ?
                                showResultPerPage ?
                                    <div className="adage-search-results-header-display" >
                                        <ConnectedDashBoard category="Providers" />
                                        <ConnectedResultePerPageDropdown property={FilterType.RESULTS_PER_PAGE} title="Results Per Page" />
                                    </div>
                                : null
                            : null
                        }
                    </div>
                    {
                        showResultPerPage ?
                            <div className="adage-search-results-header-sort">


                                <ConnectedSort property="sort" title="Sort" defaultOption={{ text: "A - Z", value: Sort.AtoZ.toString() }} />

                            </div> : null
                    }

                </div>
            }
            <Responsive mediaWidth="60rem" />

            {props.isLoading ?
                <div className="adage-search-loader-container">
                    <h2>Loading Results</h2>
                    <svg width={90} height={90} viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" className="adage-search-loader">
                        <path d="M58 30.5C58 15.3122 45.6878 3 30.5 3C15.3122 3 3 15.3122 3 30.5" stroke="#00857A" strokeWidth={5} strokeLinejoin="round" />
                        <circle cx="30.5" cy="30.5" r="27.5" stroke="url(#gradient)" strokeWidth={5} />
                        <defs>
                            <linearGradient id="gradient" x1="12.5" y1={53} x2={56} y2={45} gradientUnits="userSpaceOnUse">
                                <stop stopColor="#00857A" />
                                <stop offset={1} stopColor="#00857A" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                :
                props.list.length > 0 ?
                    <div>
                        {providers.length > 0 ?
                            <section className="adage-search-results-group">
                                <header className="adage-search-results-group-heading">
                                    <h2>Providers</h2>
                                    {
                                        providers[0].moreItemsOfType > maxItems && !showResultPerPage  ?
                                            <a href={providers[0].moreItemsURL}>{providers[0].moreItemsOfType - maxItems} more providers</a> : null
                                    }
                                </header>
                                <ul className="adage-search-results-list">
                                    {
                                        providers.map(listItem => props.listItemComponent(listItem))
                                    }
                                </ul>
                            </section>
                            : null
                        }
                        {locations.length > 0 ?
                            <section className="adage-search-results-group">
                                <header className="adage-search-results-group-heading">
                                    <h2>Locations</h2>
                                    {
                                        locations[0].moreItemsOfType > maxItems && !showResultPerPage ?
                                            <a href={locations[0].moreItemsURL}>{locations[0].moreItemsOfType - maxItems} more locations</a> : null
                                    }
                                </header>
                                <ul className="adage-search-results-list">
                                    {
                                        locations.map(listItem => props.listItemComponent(listItem))
                                    }
                                </ul>
                            </section>
                            : null
                        }
                        {events.length > 0 ?
                            <section className="adage-search-results-group">
                                <header className="adage-search-results-group-heading">
                                    <h2>Events</h2>
                                    {
                                        events[0].moreItemsOfType > maxItems && !showResultPerPage  ?
                                            <a href={events[0].moreItemsURL}>{events[0].moreItemsOfType - maxItems} more events</a> : null
                                    }
                                </header>
                                <ul className="adage-search-results-list">
                                    {
                                        events.map(listItem => props.listItemComponent(listItem))
                                    }
                                </ul>
                            </section>
                            : null
                        }
                        {care.length > 0 ?
                            <section className="adage-search-results-group">
                                <header className="adage-search-results-group-heading">
                                    <h2>Care Pages</h2>
                                    {
                                        care[0].moreItemsOfType > maxItems && !showResultPerPage  ?
                                            <a href={care[0].moreItemsURL}>{care[0].moreItemsOfType - maxItems} more Care Pages</a> : null
                                    }
                                </header>
                                <ul className="adage-search-results-list">
                                    {
                                        care.map(listItem => props.listItemComponent(listItem))
                                    }
                                </ul>
                            </section>
                            : null
                        }


                    </div>
                    :
                    <div className="adage-search-results-none">
                        <h2>No results found</h2>
                        <p>
                            Sorry, there are no results to display.
                    </p>
                    </div>
            }
            {
                showResultPerPage ?
                    <div>
                        <MediaQuery query={`(min-width: 80.01rem)`}>
                            <Pager maxNumberOfPages={6} />
                        </MediaQuery>
                        <MediaQuery query={`(min-width: 24.01rem) and (max-width: 80rem)`}>
                            <Pager maxNumberOfPages={4} />
                        </MediaQuery>
                        <MediaQuery query={`(max-width: 24rem)`}>
                            <Pager maxNumberOfPages={2} />
                        </MediaQuery>
                    </div>
                    : null
            }
        </div>
    );
}

function mapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    const filter = state.filtersState.filters['type'];

    return {
        list: state.listingState.list ? state.listingState.list : [], numberOfPages: state.listingState.numberOfPages, isLoading: state.listingState.currentlyRequesting != null,
        filterApplied: filter ? true : false
    }
}

export const ConnectedListContainer = connect(mapStateToProps)(ListContainer);